import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import { toast } from 'react-toastify';
import ProductModal from './ProductModal';
import SimpleTable from './SimpleTable';
import KeyValueTable from './KeyValueTable';
import { getSupplierDetails } from 'services/supplier/supplierDashboardService';
import { updateSupplier } from 'services/supplier/supplierDetailsService';
import FullPageSpinner from 'components/common/full-page-spinner';
import { useNavigate, useParams } from 'react-router-dom';

const Details = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [addressData, setAddressData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [orderManagement, setOrderManagement] = useState([
    { key: 'leadTimes', label: 'LEADTIMES', value: '' },
    { key: 'orderCutOffTimes', label: 'ORDER CUT OFF TIMES', value: '' },
    { key: 'deliveryDays', label: 'DELIVERY DAYS', value: '' },
    { key: 'deliveryMethod', label: 'DELIVERY METHOD', value: '' }
  ]);

  const addressColumns = [
    { header: 'DESC', accessor: 'desc' },
    { header: 'CITY', accessor: 'city' },
    { header: 'COUNTY', accessor: 'county' },
    { header: 'POST CODE', accessor: 'postCode' }
  ];

  const contactColumns = [
    { header: 'CONTACT NAME', accessor: 'name' },
    { header: 'POSITION', accessor: 'position' },
    { header: 'TEL', accessor: 'tel' },
    { header: 'EMAIL', accessor: 'email' }
  ];

  useEffect(() => {
    loadDetail();
  }, []);

  const loadDetail = async () => {
    try {
      setLoading(true);

      const res = await getSupplierDetails(id);

      if (res?.data) {
        const d = res.data;
        setDetails(d);

        // ✅ MASTER ADDRESS (row đầu tiên)
        setAddressData([
          {
            isMaster: true,
            desc: [d.street, d.locality].filter(Boolean).join(', '),
            city: d.town || '',
            county: d.county || '',
            postCode: d.postCode || ''
          }
        ]);

        // ✅ CONTACT
        setContactData([
          {
            isMaster: true,
            name: d.contactName || '',
            position: d.contactPosition || '',
            tel: d.telephone || '',
            email: d.email || ''
          }
        ]);

        // ✅ ORDER MANAGEMENT
        setOrderManagement(prev =>
          prev.map(x => ({
            ...x,
            value: d[x.key] || ''
          }))
        );
      }
    } catch (err) {
      console.error(err);
      toast.error('Load failed!');
    } finally {
      setLoading(false);
    }
  };

  const handleAddressChange = newData => {
    setAddressData(newData);
  };

  const handleContactChange = newData => {
    setContactData(newData);
  };

  const handleSave = async () => {
    try {
      const masterAddress =
        addressData.find(x => x.isMaster) || addressData[0] || {};

      const masterContact =
        contactData.find(x => x.isMaster) || contactData[0] || {};

      const payload = {
        // 🔹 ORDER MANAGEMENT
        ...orderManagement.reduce((acc, item) => {
          acc[item.key] = item.value;
          return acc;
        }, {}),

        street: masterAddress.desc || '',
        town: masterAddress.city || '',
        county: masterAddress.county || '',
        postCode: masterAddress.postCode || '',

        // 🔹 CONTACT
        contactName: masterContact.name || '',
        contactPosition: masterContact.position || '',
        telephone: masterContact.tel || '',
        email: masterContact.email || ''
      };

      const res = await updateSupplier(id, payload);

      if (res.success) {
        toast.success('Saved successfully!');
      } else {
        toast.error(res.message || 'Save failed!');
      }
    } catch (err) {
      console.error(err);
      toast.error('Save failed!');
    }
  };

  return (
    <>
      <FullPageSpinner show={loading} quantity={3} variant="success" />

      <PageHeader
        title={`${details?.supplierName || ''} DETAILS`}
        className="mb-3"
      />

      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <div style={{ padding: '20px' }}>
              {/* ===== ADDRESSES ===== */}
              <SimpleTable
                title="ADDRESSES"
                columns={addressColumns}
                data={addressData}
                emptyRows={1}
                editable
                onChange={handleAddressChange}
              />

              {/* ===== CONTACTS ===== */}
              <SimpleTable
                title="CONTACTS"
                columns={contactColumns}
                data={contactData}
                emptyRows={1}
                editable
                onChange={handleContactChange}
              />

              {/* ===== ORDER MANAGEMENT ===== */}
              <KeyValueTable
                title="ORDER MANAGEMENT"
                data={orderManagement}
                onChange={setOrderManagement}
              />

              {/* ===== SAVE BUTTON ===== */}
              <div className="text-end mt-3">
                <button className="btn btn-success" onClick={handleSave}>
                  Save
                </button>
              </div>

              {/* ===== MODAL LINK ===== */}
              <Row className="mt-4">
                <Col md={6}>
                  <h5>
                    <b>SUPPLIER PRODUCTS / VENDOR MASTER</b>
                  </h5>

                  <span
                    style={{
                      color: '#3b5d7a',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                    onClick={() => setShowModal(true)}
                  >
                    click to open
                  </span>
                </Col>

                <Col md={6}>
                  <span
                    style={{
                      color: '#3b5d7a',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                    onClick={() => navigate('/supplier/purchasing-history')}
                  >
                    <h5>
                      <b>Purchasing History Link</b>
                    </h5>
                  </span>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>

      {/* ===== MODAL ===== */}
      <ProductModal
        show={showModal}
        onHide={() => setShowModal(false)}
        supplierCode={details.supplierCode}
      />
    </>
  );
};

export default Details;
